<template>
  <div>
    <el-container>
      <el-header height="90px">
        <headCom></headCom>
      </el-header>
      <el-main>
        <div id="content_div">
          <div v-if="showPageName === 'shoppingCartSelectPage'">
            <checkCom
              :reCheckUnpaiedState="reCheckUnpaiedStatePropertie"
              v-on:nextStepEvent="goToPayTypeChoosePageFun"
            ></checkCom>

            <div class="titleClass">
              <tempListCom
                v-on:nextStepEvent="goToPayTypeChoosePageFun"
              ></tempListCom>
            </div>
          </div>
          <div v-else-if="showPageName === 'payTypeSelectPage'">
            <payTypeCom
              :scId="emitShoppingCartId"
              v-on:gotoRealPayPageEvent="realPayPageJumpFun"
              @goBackEvent="getBackToShoppingCartSelectPageFun"
            ></payTypeCom>
          </div>
          <div v-else-if="showPageName === 'payTypeJumpPage'">
            <payTypeJumpCom
              :payType="emitPayTypeStr"
              :scId="emitShoppingCartId"
              :sumMoney="emitPaySumMoney"
              v-on:intervalAddressEvent="nowPayCheckIntervalAddressFun"
            ></payTypeJumpCom>
            <div id="backStep">
              <span
                style="cursor: pointer;"
                type="primary"
                @click="getBackToPayTypeSelectPageFun"
                >返回上一步</span
              >
            </div>
          </div>
        </div>
      </el-main>
      <el-footer height="30px">
        <footCom></footCom>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
// import head from '@/components/public/head_shopCard.vue'
import head from '@/components/public/head_searchbox'
import foot from '@/components/public/footer.vue'

import checkUnpaiedTrade from '@/components/shoppingCarts/unpaiedTrades/check.vue'
import tempListCom from '@/components/shoppingCarts/templatesList/tempList.vue'
import payTypeCom from '@/components/shoppingCarts/payTypes/payTypeChoose.vue'
import payTypeJumpCom from '@/components/shoppingCarts/payTypes/payTypeJump.vue'

export default {
  data () {
    return {
      showPageName: 'shoppingCartSelectPage', // 默认进入模板选择页面
      emitShoppingCartId: 0,
      emitPayTypeStr: '',
      emitPaySumMoney: null,
      emitPayTypeCheckIntervalAddress: null,
      reCheckUnpaiedStatePropertie: false
    }
  },
  methods: {
    // 进入支付类型选择页面
    goToPayTypeChoosePageFun (scId) {
      this.emitShoppingCartId = scId
      this.showPageName = 'payTypeSelectPage'
    },
    // 进入真实的支付页面
    realPayPageJumpFun (payType, sumMoney) {
      // alert('用户选择了' + payType)
      // console.log(sumMoney)
      this.emitPayTypeStr = payType
      this.emitPaySumMoney = sumMoney
      this.showPageName = 'payTypeJumpPage'
      // 用户选择了一个付款方式, 直接打开用户可以正式支付的组件
    },
    // 返回模板选择页面(购物车添加页面)
    getBackToShoppingCartSelectPageFun () {
      this.showPageName = 'shoppingCartSelectPage'
      // 只要是重新进入选择的列表中就要重新监听请求看是否已经付款了
      this.reCheckUnpaiedStatePropertie = !this.reCheckUnpaiedStatePropertie
    },
    // 返回支付类型选择页面, 这里默认使用之前已经提交的购物车ID
    getBackToPayTypeSelectPageFun () {
      // 取消检查用户是否已经付费的定时器
      clearInterval(this.emitPayTypeCheckIntervalAddress)
      // 返回类型选择页面
      this.showPageName = 'payTypeSelectPage'
    },
    // 无论是哪一种支付方式都需要一个定时器来监听用户是否付款, 这里的参数就是定时器的地址, 用户点击上一步后只能在这里取消定时器
    nowPayCheckIntervalAddressFun (address) {
      this.emitPayTypeCheckIntervalAddress = address
    }
  },
  components: {
    headCom: head, // 统一抬头栏
    footCom: foot, // 统一页面下方提示信息
    tempListCom: tempListCom, // 模板列表选择(购物车添加)组件
    checkCom: checkUnpaiedTrade, // 检查用户之前是否有未支付的记录组件
    payTypeCom: payTypeCom, // 支付类型选择页面
    payTypeJumpCom: payTypeJumpCom // 真实的支付类型跳转页面
  },
  beforeUnmount () {
    // 用户没有点击上一步就直接进入其他页面, 测试过是可以的
    // console.log('我进入销毁方法了...')
    // 取消检查用户是否已经付费的定时器
    clearInterval(this.emitPayTypeCheckIntervalAddress)
  }
}
</script>

<style scoped>
.controlWidthCalss {
  width: 5rem;
}
#content_div {
  color: red;
}
.titleClass {
  color: red;
}
/* 内容撑开的样式处理(head标签和foot中间的内容)---- 开始 */
#content_div {
  width: -webkit-calc(80%);
  width: -moz-calc(80%);
  width: calc(80%);
  height: -webkit-calc(100vh - 170px);
  height: -moz-calc(100vh - 170px);
  height: calc(100vh - 170px);
  margin-left: auto;
  margin-right: auto;
}
.el-header {
  color: #333;
  text-align: center;
  padding-top: 10px;
}
.el-footer {
  color: #333;
  text-align: center;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #333;
  text-align: center;
  overflow: hidden;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

#backStep {
  height: 100px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  padding-top: 60px;
}

#backStep .el-link.el-link--primary {
  color: #fff;
  font-size: 20px;
}
/* 内容撑开的样式处理---- 结束 */
</style>
